import React, { useId } from "react";
import styles from "./ComparadorTasaFactoring.module.scss";

// Comparador de tipo de tasa para proveedores que liquidan con DOS fórmulas según el comprobante
// (hoy Fingo / Santander — ver tasaSeEligePorComprobante en src/utils/calculoFactoring.js, P1.17).
// Muestra el cálculo anticipado y el vencido lado a lado; el usuario elige el que coincide con el
// "Monto a Recibir" de su comprobante, y ese es el que se guarda. Lo usan NuevaOperacionModal
// (Factoring) y el tab Factoring de PlanCuotasModal: los dos le pasan el resultado de
// calcularOperacionFactoring llamado una vez por tipo de tasa.
const OPCIONES = [
  { tipo: "anticipada", titulo: "Tasa anticipada", pista: "Comprobante «Office Banking» · Tasa Anticipada" },
  { tipo: "vencida", titulo: "Tasa vencida", pista: "Comprobante «Fintech» · sin tipo de financiamiento" },
];

const ComparadorTasaFactoring = ({ resultados, comision, seleccion, onSeleccionar, fmt }) => {
  const name = useId();
  return (
    <div>
      <div className={styles.leyenda}>Elegí el que coincide con el Monto a Recibir de tu comprobante</div>
      <div className={styles.columnas} role="radiogroup">
        {OPCIONES.map(({ tipo, titulo, pista }) => {
          const r = resultados[tipo];
          const activa = seleccion === tipo;
          return (
            <label key={tipo} className={`${styles.columna} ${activa ? styles.activa : ""}`}>
              <div className={styles.titulo}>
                <input type="radio" name={name} value={tipo} checked={activa} onChange={() => onSeleccionar(tipo)} />
                <span>{titulo}</span>
              </div>
              <div className={styles.pista}>{pista}</div>
              <div className={styles.fila}>
                <span>Diferencia precio:</span>
                <span className={styles.costo}>{fmt(r.diferenciaPrecio)}</span>
              </div>
              <div className={styles.fila}>
                <span>Comisión:</span>
                <span className={styles.costo}>{fmt(comision)}</span>
              </div>
              <div className={`${styles.fila} ${styles.giro}`}>
                <span>Giro a recibir:</span>
                <span className={styles.giroMonto}>{fmt(r.giroARecibir)}</span>
              </div>
              <div className={styles.fila}>
                <span>Excedentes:</span>
                <span className={styles.excedentes}>{fmt(r.excedentes)}</span>
              </div>
            </label>
          );
        })}
      </div>
      {!seleccion && <div className={styles.aviso}>Sin elección no se puede registrar la operación.</div>}
    </div>
  );
};

export default ComparadorTasaFactoring;
